import pageContext from '@bingads-webui-static-legacy/page-context';
import Backbone from 'backbone';
import _ from 'underscore';
import {
  AudienceAdvancedTargetSettings,
  AudienceTargetInfo,
} from '@bingads-webui-campaign-legacy/audience-campaign/loader';


export default class AdGroupTargets extends Backbone.View {
  initialize({
    campaign,
    supportCashbackSettings = false,
    isMSStoreAdsGAWorkflow = false,
  }) {
    const adGroupTargetInfo = new AudienceTargetInfo({
      resourceName: 'AdGroupCriterion',
      listenToLocationCriterion: false,
      useLocationControl: false,
      initAudienceAssociationView: false,
    });
    const campaignTargetInfo = new AudienceTargetInfo({
      resourceName: 'CampaignCriterion',
      listenToLocationCriterion: false,
      useLocationControl: false,
      initAudienceAssociationView: false,
    });

    this.viewContext = {
      accountCurrencyCode: pageContext.AccountCurrencyCode,
      currentCampaign: campaign,
      currentAdGroup: {},
      level: 'adgroup',
    };

    this.asyncTask = campaignTargetInfo.fetchCriterions(campaign.Id)
      .then(() => {
        this.childView = new AudienceAdvancedTargetSettings({
          viewContext: this.viewContext,
          scenario: 'adgroup-creation',
          currentLevelTargetInfo: adGroupTargetInfo,
          parentLevelTargetInfo: campaignTargetInfo,
          supportCashbackSettings,
          isMSStoreAdsGAWorkflow,
        });
      });
  }

  render() {
    super.render();

    this.asyncTask.then(() => {
      this.$el.empty().append(this.childView.render().$el);
    });

    return this;
  }

  validate() {
    return this.childView ? this.childView.validate() : true;
  }

  getValues(adgroupName, campaignName, adgroupId) {
    if (!this.childView) {
      return {};
    }

    this.viewContext.currentAdGroup.Name = adgroupName;
    if (adgroupId) {
      this.viewContext.currentAdGroup.Id = adgroupId;
    }

    const rawData = this.childView.getData();

    const mappedCriterions = _.map(rawData.AdGroupCriterions, (criterion) => {
      if (adgroupId) {
        return _.defaults({
          AdGroup: {
            Id: adgroupId,
          },
        }, criterion);
      }
      return _.defaults({
        CampaignName: campaignName,
        AdGroupName: adgroupName,
      }, _.omit(criterion, 'AdGroup'));
    });

    return _.defaults({
      AdGroupCriterions: mappedCriterions,
    }, rawData);
  }

  fillCriterionsWithId(criterions) {
    this.childView.fillCriterionsWithId(criterions);
  }

  remove() {
    if (this.childView) {
      this.childView.remove();
    }

    super.remove();
  }
}
